// VIEWS
export const UPLOAD_ART_VIEW = 'design';
export const CUSTOMIZE_VIEW = 'customize';
export const WHITE_INK_OPTIONS_VIEW = 'white-options';
export const ERROR_MODE_VIEW = 'error';
export const APPLY_CODES_VIEW = 'apply-codes';
export const LOGIN_SIGNUP_VIEW = 'login-signup';

// PRODUCT PROFILES
export const ROLL_LABEL = 'ROLL_LABEL';
export const DESIGN_IN_LABEL = 'DESIGN_IN_LABEL';
export const CUSTOM_SIZE_STICKER = 'CUSTOM_SIZE_STICKER';
export const CUSTOM_SHAPE_STICKER = 'CUSTOM_SHAPE_STICKER';

// HELP DIALOG
export const HELP_SECTION_PRODUCT_TYPE = 'HELP_SECTION_PRODUCT_TYPE';
export const HELP_SECTION_UPLOAD_ART = 'HELP_SECTION_UPLOAD_ART';
export const HELP_SECTION_ART_SIZE_POSITION = 'HELP_SECTION_ART_SIZE_POSITION';
export const HELP_SECTION_APPLY_CODES = 'HELP_SECTION_APPLY_CODES';
export const HELP_SECTION_WHITE_INK = 'HELP_SECTION_WHITE_INK';

export const HELP_TOPIC_UPLOAD_ART = 'help-topic-upload-art';
export const HELP_TOPIC_UPLOAD_ART_LABEL_SHAPE_YOUR_UPLOAD = 'help-topic-upload-label-shape';
export const HELP_TOPIC_UPLOAD_ART_PREPARE_FILES = 'help-topic-upload-art-prepare-files';

export const HELP_TOPIC_ART_SIZE_POSITION = 'help-topic-art-position';
export const HELP_TOPIC_ART_SIZE_POSITION_STB_LINES = 'help-topic-STB-lines';
export const HELP_TOPIC_SHAPE_CORNERS_SIZE = 'help-topic-shape-corners-size-sheet';
export const HELP_TOPIC_ART_SIZE_POSITION_STRETCHED = 'help-topic-art-position-art-stretched';
export const HELP_TOPIC_ART_SIZE_POSITION_OPTIMIZED = 'help-topic-art-position-art-optimized';
export const HELP_TOPIC_ART_SIZE_POSITION_FLATTENED = 'help-topic-art-position-art-flattened';
export const HELP_TOPIC_ART_SIZE_POSITION_ADJUSTED = 'help-topic-art-position-art-adjusted';
export const HELP_TOPIC_WHITE_INK = 'help-topic-white-ink';
export const HELP_TOPIC_WHITE_INK_OPTIONS = 'help-topic-white-ink-options';
export const HELP_TOPIC_WHITE_INK_IN_YOUR_UPLOAD = 'help-topic-white-ink-in-your-upload';

export const HELP_TOPIC_PRODUCT_TYPE = 'help-topic-product-type';
export const HELP_TOPIC_TRANSPARENCY_CODES = 'help-topic-product-type-designIn';
export const HELP_TOPIC_ROLL_LABELS = 'help-topic-product-type-roll';
export const HELP_TOPIC_DIE_CUT_STICKERS = 'help-topic-product-type-sticker';
export const HELP_TOPIC_SHEET_LABELS = 'help-topic-product-type-sheet';

export const HELP_TOPIC_CONTACT_US = 'help-topic-contact-us';

export const HELP_TOPIC_APPLY_CODES = 'help-topic-apply-codes';
export const HELP_TOPIC_APPLY_CODES_SIGN_IN = 'help-topic-apply-codes-sign-in';
export const HELP_TOPIC_APPLY_CODES_REGISTER = 'help-topic-apply-codes-register';
export const HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES = 'help-topic-apply-codes-authorize-codes';
export const HELP_TOPIC_APPLY_CODES_REQUEST_CODES = 'help-topic-apply-codes-request-codes';
export const HELP_TOPIC_APPLY_CODES_UPLOAD_CODES = 'help-topic-apply-codes-upload-codes';

export const HELP_TOPIC_STICKER_SIZE = 'help-topic-sticker-size';
export const HELP_TOPIC_SHEET_SIZE = 'help-topic-sheet';

export const HELP_TOPIC_STICKER_SIZE_POSITION = 'help-topic-sticker-size-position';

// WORKING AREA WARNINGS
export const WORKING_AREA_WARNING_OPTIMIZED_CODES = [601, 605];
export const WORKING_AREA_WARNING_STRETCHED_CODE = 609;
export const WORKING_AREA_WARNING_FLATTENED_CODE = 608;
export const WORKING_AREA_WARNING_ADJUSTED_CODE = 607;

export const WORKING_AREA_WARNING_CUSTOM_SHAPE_CODE = 'WORKING_AREA_WARNING_CUSTOM_SHAPE_CODE';
export const WORKING_AREA_WARNING_HPI_WHITE_CODE = 'WORKING_AREA_WARNING_HPI_WHITE_CODE';
export const WORKING_AREA_WARNING_CUSTOM_SHAPE_HPI_WHITE_CODE = 'WORKING_AREA_WARNING_CUSTOM_SHAPE_HPI_WHITE_CODE';

export const WORKING_AREA_WARNING_OPTIMIZED_KEY = 'qau-working-area-error-tip-optimized';
export const WORKING_AREA_WARNING_STRETCHED_KEY = 'qau-working-area-error-tip-stretched';
export const WORKING_AREA_WARNING_FLATTENED_KEY = 'qau-working-area-error-tip-flattened';
export const WORKING_AREA_WARNING_ADJUSTED_KEY = 'qau-working-area-error-tip-adjusted';
export const WORKING_AREA_WARNING_CUSTOM_SHAPE_KEY = 'qau-working-area-error-tip-custom-shape';
export const WORKING_AREA_WARNING_HPI_WHITE_KEY = 'qau-working-area-error-tip-hpi-white';
export const WORKING_AREA_WARNING_CUSTOM_SHAPE_HPI_WHITE_KEY = 'qau-working-area-error-tip-custom-shape-hpi-white';

// APPLY CODES VIEW STEPS
export const UPLOAD_CODES_FLOW = 'UPLOAD_CODES_FLOW';
export const REQUEST_CODES_FLOW = 'REQUEST_CODES_FLOW';
export const APPLY_CODES_FLOW_SELECTION = 'APPLY_CODES_FLOW_SELECTION';
export const AUTHORIZE_CODES_FLOW = 'AUTHORIZE_CODES_FLOW';
export const AUTHORIZATION_SENT = 'AUTHORIZATION_SENT';
export const LOGIN_SIGNUP_FLOW = 'LOGIN_SIGNUP_FLOW';
export const LOGIN_FORM = 'LOGIN_FORM';
export const FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD_FORM';
export const SIGNUP_FORM = 'SIGNUP_FORM';

// APPLY CODES VIEW -- OTHER
export const USA_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const CHINA_PROVINCES = [
  'Anhui',
  'Beijing',
  'Chongqing',
  'Fujian',
  'Gansu',
  'Guangdong',
  'Guangxi Zhuang',
  'Guizhou',
  'Hainan',
  'Hubei',
  'Heilongjiang',
  'Henan',
  'Hong Kong',
  'Hebei',
  'Hunan',
  'Inner Mongolia',
  'Jiangsu',
  'Jiangxi',
  'Jilin',
  'Liaoning',
  'Macau',
  'Ningxia Hui',
  'Qinghai',
  'Shaanxi',
  'Shandong',
  'Shanghai',
  'Shanxi',
  'Sichuan',
  'Taiwan',
  'Tianjin',
  'Tibet',
  'Xinjiang Uyghur',
  'Yunnan',
  'Zhejiang',
  'Other',
];

export const CANADA_PROVINCES = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
  'Other',
];

export const COUNTRIES = { USA: USA_STATES, Canada: CANADA_PROVINCES, China: CHINA_PROVINCES, Other: [] };

export const CORNER_TYPES = {
  ROUNDED_CORNER: 'rounded',
  SQUARED_CORNER: 'squared',
  SCALLOPED_CORNER: 'scalloped_corner',
  SMOOTH_EDGE: 'smooth_edge',
  SCALLOPED_EDGE: 'scalloped_edge',
};

export const HELP_PRODUCT_TYPES_LABELS = ['roll', 'sticker', 'sheet', 'designIn'];
export const HELP_UPLOAD_ART_LABELS = ['roll-', 'sticker-', 'sheet-', ''];
export const HELP_ART_SIZE_LABELS = ['sticker-size', 'sticker-size-position', 'sheet', 'art-position'];
export const HELP_WHITE_INK_LABELS = ['sheet-', ''];
